import { faCircleInfo } from "@jewlr/pro-light-svg-icons/faCircleInfo"
// import { faTag } from "@jewlr/pro-regular-svg-icons/faTag"
import {
  Box,
  Button,
  Flex,
  FontAwesomeIcon,
  MediaFlex,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import { openModal } from "components/modal"
import { IS_AU, IS_CA, isTestMode, IS_JEWLR } from "helpers/application"
import { to_currency } from "helpers/number"

import WizardPricingLoading from "./loaders/wizard-pricing-loading"
import Badge from "./wizard-header/badge"

const Pricing = styled(Typography).attrs((props) => ({
  color: "grey.62",
  fontSize: 12,
  letterSpacing: "1px",
  ...props,
}))``

const InternalProductPrice = ({
  onSale,
  prefStore,
  pricing,
  saleEnds,
  wizardLoading,
}) => {
  if (!prefStore || !Object.keys(pricing).length) {
    return <WizardPricingLoading />
  } else if (pricing.price_to_display <= 0 || wizardLoading) {
    return ""
  }

  const percentageSavings = (
    ((pricing.retail_price - pricing.price_to_display) * 100) /
    pricing.retail_price
  ).toFixed(0)

  const currencyCode = IS_AU() ? "AU" : IS_CA() ? "C" : ""

  const handleHonestPricingClick = () => {
    openModal("#honest-pricing")
    if (!isTestMode) {
      dataLayer.push({
        event: "opened-pdp-honest-pricing-popup",
      })
    }
  }

  return (
    <Box mb={{ _: 2, tablet: "12px" }} mt={{ _: 1, tablet: 0 }}>
      <Flex alignItems="center">
        {onSale && (
          <Typography
            color="grey.65"
            fontSize="24px"
            lineHeight="34px"
            mr="4px"
          >
            <strike>
              {currencyCode}
              {to_currency(pricing.regular_pricing)}
            </strike>
          </Typography>
        )}
        <Typography
          as="h2"
          bold
          color={onSale ? "ruby" : "black"}
          data-cy="product-item-price"
          fontSize={{ _: "34px", tablet: "28px" }}
          lineHeight={{ _: "42px", tablet: "34px" }}
        >
          {currencyCode}
          {to_currency(pricing.price_to_display)}
        </Typography>
        {onSale && (
          <MediaFlex alignItems="center" lessThan="tablet" ml="12px">
            <Badge />
          </MediaFlex>
        )}
      </Flex>
      {IS_JEWLR() && (
        <Flex
          alignItems="center"
          fontSize="12px"
          letterSpacing={{ _: "0.02em", tablet: "1px" }}
          lineHeight="1"
          mt={{ _: "4px", tablet: 0 }}
        >
          <Typography color="ruby" fontWeight={{ _: "600", tablet: "500" }}>
            SAVE {percentageSavings}%
          </Typography>
          <Box
            bg={{ _: "black", tablet: "grey.35" }}
            height="12px"
            mx={{ _: "4px", tablet: 1 }}
            role="separator"
            width="1px"
          />
          <Button
            aria-label={`Compare to ${to_currency(
              pricing.retail_price
            )} Estimated Retail. Read more about our value pricing`}
            onClick={handleHonestPricingClick}
            variant="text"
          >
            <Typography
              fontSize={{ _: "10px", tablet: "12px" }}
              fontWeight={{ _: "600", tablet: "300" }}
              letterSpacing={{ _: "0.02em", tablet: "1px" }}
              lineHeight={{ _: "1", tablet: "14px" }}
              textTransform={{ _: "uppercase", tablet: "none" }}
            >
              Compare to {to_currency(pricing.retail_price)} Estimated Retail
            </Typography>
            <FontAwesomeIcon
              fontSize={{ _: "12px", tablet: "10px" }}
              icon={faCircleInfo}
              ml="4px"
            />
          </Button>
        </Flex>
      )}
      {new Date().setHours(0, 0, 0, 0) <=
        new Date(saleEnds).setHours(0, 0, 0, 0) && (
        <Pricing color="grey.500" letterSpacing="0" mt="4px">
          Sale ends {saleEnds}
        </Pricing>
      )}
    </Box>
  )
}

InternalProductPrice.propTypes = {
  onSale: PropTypes.bool,
  prefStore: PropTypes.bool,
  pricing: PropTypes.object,
  saleEnds: PropTypes.string,
  wizardLoading: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    onSale: state.choices.sku && !!state.choices.sku.sale_price,
    prefStore: state.wizardUI.prefStore,
    pricing: state.wizardUI.currentPricing,
    saleEnds: state.wizard.price_and_promo.sale_ends,
    wizardLoading: state.wizard.loading,
  }
}

const ProductPrice = connect(mapStateToProps)(InternalProductPrice)

export default ProductPrice
